import React from "react";
import swal from "sweetalert";
import { useDetail, useQuery, useSet } from "seed/gql";
import { PARTICIPANT_ROLE, SET_PARTICIPANT_ROLE } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/presentation/sections/settings/roles/RoleFormView.view";

function RoleFormEdit({ roleId, flowId, reqRoles, onClose }) {

  const [callSet] = useSet(SET_PARTICIPANT_ROLE, {
    onCompleted: () => {
      onClose();
      reqRoles.refetch();
    },
    onError: (error) => {
      swal("Error", l("No fue posible editar el rol%PA065"), "error");
    },
  });

  const reqRole = useDetail(PARTICIPANT_ROLE, roleId);
  const reqLicenses = useQuery(`{ licenses { name } }`, `flow.id=${flowId}`, { orderBy: "id" });

  const onSubmit = (values) => {
    const { name, requiredLicense } = values;
    if (!name) {
      swal("Error", l("El nombre es requerido%PA064"), "error");
      return;
    }
    callSet({
      id: roleId,
      name: name,
      requiredLicense: requiredLicense ? Number(requiredLicense) : null,
    });
  }

  if (reqRole.loading) return <Loading />;
  if (reqRole.error) return "Error";

  const { participantRole = {} } = reqRole.data;
  const { licenses = [] } = reqLicenses.data;

  return (
    <View
      role={{
        name: participantRole.name,
        requiredLicense: participantRole.requiredLicense?.id ?? "",
      }}
      licenses={licenses}
      isEdit={true}
      onSubmit={onSubmit}
    />
  );
}

export default RoleFormEdit;